// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/pave-checklist.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/pave-checklist/pave-checklist.js';

mount([g0]);
